import { gql } from '@apollo/client';

/** mutation to create user comment for FR2052A rule */
export const CREATE_FR2052A_USER_COMMENT = gql`
mutation createFR2052AUserComment($input: CreateFR2052AUserCommentInput) {
	createFR2052AUserComment(input: $input)
}`;

/** mutation to update user comment for FR2052A rule */
export const UPDATE_FR2052A_USER_COMMENT = gql`
mutation updateFR2052AUserComment($input: UpdateFR2052AUserCommentInput) {
	updateFR2052AUserComment(input: $input)
}`;

export const DELETE_FR2052A_USER_COMMENT = gql`
mutation deleteFR2052AUserComment($input: DeleteFR2052AUserCommentInput) {
	deleteFR2052AUserComment(input: $input)
}`;

export const CREATE_CLASSIFY_AUDIT_LOGS_FOR_FR2052A = gql`
mutation createClassifyAuditLogForFR2052A($input: ClassifyFR2052AInput) {
	createClassifyAuditLogForFR2052A(input: $input)
}`;
